import React from 'react';
import ReactDOM from 'react-dom/client'; // Updated import
import './index.css';
import 'katex/dist/katex.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')); // Create root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);